import { CompanySettings } from '@innovyze/stylovyze';

export const generateLuxonFormatToken = (
	settings: CompanySettings,
	includeSeconds = true,
): string => {
	const { hourCycle12, dateFormat } = settings;

	const date =
		dateFormat && dateFormat.startsWith('D') ? 'dd/MM/yyyy' : 'MM/dd/yyyy';

	let time = hourCycle12 ? 'hh:mm:ss a' : 'HH:mm:ss';
	time = includeSeconds ? time : time.replace(':ss', '');

	return date + ' ' + time;
};
